import { Link } from 'react-router-dom'

const NotFound = () => {
  return (
    <div className="min-h-screen bg-linear-to-r from-blue-50 to-green-50 flex items-center justify-center px-6">
      <div className="max-w-lg text-center">
        <p className="text-sm font-semibold uppercase tracking-[0.4em] text-teal-700">404</p>
        <h1 className="mt-4 text-4xl font-bold text-gray-900">Page not found</h1>
        <p className="mt-4 text-lg text-gray-700">
          This page does not exist. Choose a path below to continue.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-full bg-[#006D6D] px-6 py-3 text-sm font-semibold text-white hover:bg-[#055a5a] transition-colors"
          >
            Home
          </Link>
          <Link
            to="/main"
            className="inline-flex items-center justify-center rounded-full border border-[#006D6D] px-6 py-3 text-sm font-semibold text-[#006D6D] hover:bg-white/70 transition-colors"
          >
            Longevity support
          </Link>
        </div>
      </div>
    </div>
  )
}

export default NotFound
